import { api } from "@/lib/api/client";

/**
 * Something the system told the person signed in.
 *
 * Named `AppNotification` rather than `Notification`, which is a browser
 * global.
 */
export interface AppNotification {
  id: string;
  /** What kind of thing happened, e.g. `task_assigned`. Not for reading. */
  type: string;
  title: string;
  body: string | null;
  /** Where in the application it is about, when it is about somewhere. */
  link_path: string | null;
  read_at: string | null;
  created_at: string;
}

export const notificationKeys = {
  all: ["notifications"] as const,
  list: (limit: number) => [...notificationKeys.all, "list", limit] as const,
  unread: () => [...notificationKeys.all, "unread"] as const,
};

export const notificationApi = {
  list: (limit: number) => api.get<AppNotification[]>("/me/notifications", { query: { limit } }),

  unread: () => api.get<{ unread: number }>("/me/notifications/unread-count"),

  markRead: (id: string) => api.post<AppNotification>(`/me/notifications/${id}/read`),

  markAllRead: () => api.post<{ marked: number }>("/me/notifications/read-all"),
};
